<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Poste aux lettres" />
            <PosteLettre />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PosteLettre from '../Services/PosteLettre'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PosteLettrePage',
    components: {
        NavBar,
        PageTitle,
        PosteLettre,
        FooterComp,
    }
}
</script>